export const styles = theme => ({
    loggedOut: {
        margin: 25,
    }
});